import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { DashboardApiService } from 'src/app/core/services/api/dashboard-api.service';
import { PrintService } from 'src/app/core/services/print.service';
import { ClientSummaryModalComponent } from 'src/app/shared/client-summary-modal/client-summary-modal.component';
import { Client, ClientLite } from 'src/app/shared/models/clients/client';
import { ClientSearchParams } from 'src/app/shared/models/clients/clientSearchParams';

@Component({
  selector: 'app-new-clients-list',
  templateUrl: './new-clients-list.component.html',
  styleUrls: ['./new-clients-list.component.scss']
})
export class NewClientsListComponent implements OnInit {
  SelectionType = SelectionType;
  
  @Input() items: ClientLite[] = [];
  @Input() count = 0;
  @ViewChild('hearingsTable') hearingsTable: any;
  @ViewChild('clientSummaryModal') clientSummaryModal: ClientSummaryModalComponent;
  
  @Output() updatedCount = new EventEmitter<number>();
  params: ClientSearchParams = new ClientSearchParams();
  constructor(private spinner: NgxSpinnerService,
    private clientsApi: ClientsApiService,
    private dashboardApi: DashboardApiService,
    private printService: PrintService) {
    this.loadItems();
    }

  ngOnInit(): void {
  }


  loadItems() {
    this.spinner.show();
    this.dashboardApi.getNewClients(this.params).subscribe(
      r => {
        this.items = r.results;
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

  onSelectClientSummary({ selected }) {
    this.spinner.show();
    this.clientsApi.getClientSummary(selected[0].id).subscribe(
      r => {
        this.spinner.hide();
        this.clientSummaryModal.open(r);
      }
    );
  }

  updateNewClients(client: Client) {
    this.count = this.count > 0 ? --this.count : this.count;
    this.items = this.items.filter(f => f.id !== client.id);
    this.updatedCount.emit(this.count);
  }
}
